import { useMutation } from 'react-query';
import { ProjectMilestonesApi } from '../../../api/ProjectApi/ProjectMilestonesApi';
import { useInvalidateProjectMilestones } from './useProjectMilestones';

export const useMilestoneGoalDelete = () => {
  const invalidateMilestones = useInvalidateProjectMilestones();

  return useMutation(ProjectMilestonesApi.deleteProjectMilestoneGoal, {
    onSuccess: (_, input) => {
      invalidateMilestones(input.projectUid);
    },
  });
};
